module.exports = __webpack_public_path__ + "static/img/iphoneX-bg.00139a3d.jpg";